(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDeleteController',PhotoIbqDeleteController);

    PhotoIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Photo'];

    function PhotoIbqDeleteController($uibModalInstance, entity, Photo) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Photo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
